<template>
<div class="page-header">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light" role="navigation">
      <a href="#" class="navbar-brand">
        <img :src="data.logo" class="company-logo" alt="DigitalHealthTechnology">
      </a>
      <button @click="toggleNav" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarContent" aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarContent">
        <ul class="navbar-nav ml-auto">
          <li v-for="(item, index) in data.nav.items" :key="index"
            class="nav-item"
            >
            <a v-if="item.anchor !== 'home' && item.anchor !== 'covid'" :href="`#${item.anchor}`" @click="toggleNav" class="nav-link">{{item.link}}</a>
            <router-link :to="'/covid'" v-if="item.anchor === 'covid'" class="nav-link btn btn-danger btn--covid">{{item.link}}</router-link>
            
            <router-link :to="'/'" v-if="item.anchor === 'home'" class="nav-link">Home</router-link>
          </li>
          <li v-if="page === 'covid'" class="nav-item">
            <a href="#apps" @click="toggleNav" class="nav-link">Apps</a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</div>
</template>
<script>
export default {
  props: ['data', 'page'],
  methods: {
    toggleNav () {
      document.querySelector('.navbar-collapse').classList.toggle('collapse');
      document.querySelector('.page-header').classList.toggle('page-header--mobileFullwidth');
    },
    handleScroll () {
      const header = document.querySelector('.page-header');
      const sectionHero = document.querySelector('.section--hero') || document.querySelector('.section--header');
      const scrollPosition = window.scrollY;

      const sectionHeroHeight = sectionHero.getBoundingClientRect().height;

      if (scrollPosition > sectionHeroHeight && !header.classList.contains('sticky')) {
        header.classList.add('sticky');
      }

      if (scrollPosition < sectionHeroHeight && header.classList.contains('sticky')) {
        header.classList.remove('sticky');
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  }

}
</script>

<style lang="scss">
.page-header {
  position: absolute;
  top: 1rem;
  left: 0;
  width: 100%;
  height: 6.25rem;
  z-index: 12;
  color: $white;

  &--mobileFullwidth {

    @media (max-width: 991.98px) {
      width: 100vw;
      background-color: rgba($color: $primary, $alpha: 0.9);
      height: auto;
    }
  }

  transition: all .3s ease-in;

  .company-logo {
    height: 5rem;
    width: auto;
    object-fit: contain;
  }

  .navbar {
    .navbar-toggler {
      border-color: rgba($color: $white, $alpha: 0.7);
      .navbar-toggler-icon {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba(255, 255, 255, 0.7)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
      }

      &:focus {
        outline: none;
      }
    }

    .nav-link {
      padding: 1rem 1.75rem;
      color: $white;
      font-size: 1rem;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 2px;

      &:hover {
        cursor: pointer;
        color: $secondary;
      }
    }
  }

  &.sticky {
    position: sticky;
    top: 0;
    height: auto;
    background-color: rgba($color: $primary, $alpha: 0.75);

    .navbar {
      padding: .5rem 1.75rem;
    }

    .company-logo {
      height: 3.25rem;
    }
  }

   .btn.btn--covid {
      border-radius: 1.25rem;
      padding: .75rem 1.75rem;
      margin: .25rem 0;

      &:hover {
        color: $white;
      }
    }
}


</style>